
const BASE_URL = "https://apidev.wefroth.com/";
const MAIN_BASE_URL = "https://futsaloz.wefroth.com/";

export const environment = {
  API_ENDPOINT: BASE_URL + "api/", //http://futsaloz.xylixys.com/

  API_PHOTO_ID: BASE_URL + "api/uploads/uploads/documents/",
  API_CLUB_LOGO: BASE_URL + "api/uploads/uploads/clubs/",
  API_TEAM_LOGO: BASE_URL + "api/uploads/uploads/team/",
  API_PLAYER_IMG: BASE_URL + "api/uploads/uploads/profile_image/",
  API_FRANCHISE_IMG: BASE_URL + "api/uploads/uploads/franchise/",
  API_VENUE_IMG: BASE_URL + "api/uploads/uploads/venues/",
  API_TERMS_CONDITION: MAIN_BASE_URL + "terms-condition.html",
  production: false,
  local: false,
  development: true,
  SQUARE_SANDBOX: {
    APPLICATION_ID: 'sandbox-sq0idb-sn6yowOikAw_CWawaquEpA',
    ACCESS_TOKEN: 'EAAAEBvjWahNFLARC5WbUfSGv67OIraQdfwhKrj0dTsd5enkLb8WWkfhxjEMpnpc',
    URL:'https://sandbox.web.squarecdn.com/v1/square.js'
    // APPLICATION_ID: 'sandbox-sq0idb-sGaTa44SkOI7ATdVz-269Q', // Darshan bhai provided
    // ACCESS_TOKEN: 'EAAAEK4HnCUv3iyKvYTgn8dEEGGOGp38pQz7U8lWBgqQaigDCkfE5PSfORFYCBoe', // Darshan bhai provided
  }
};